import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { StatusChip, StatusType } from '@roc/ui';
import { observer } from 'mobx-react';
import { useStatusDashboardStore } from '../hooks/useStatusDashboardStore';
import { DashboardCard } from './dashboardCard';
import { DASHBOARD_COLORS, useStatusDashboardStyles } from './statusDashboardStyles';

const HISTORY_COLUMNS = '120px 80px minmax(0,1fr) 200px 110px';

const RecipientSummary = observer(() => {
  const classes = useStatusDashboardStyles();
  const theme = useTheme();
  const { statusDashboardStore: store } = useStatusDashboardStore();
  const recipient = store.recipientProfile;

  return (
    <DashboardCard>
      <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 9999,
            background: theme.palette.primary.main,
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            fontWeight: 700,
          }}
        >
          {recipient.name.slice(0, 1)}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 220 }}>
          <h2 className={classes.cardTitle} style={{ fontSize: 20 }}>{recipient.name}</h2>
          <span className={classes.muted} style={{ fontSize: 13 }}>
            {recipient.segment} · {recipient.address} · {recipient.phone}
          </span>
        </div>
        <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
          {store.recipientStats.map(stat => (
            <div key={stat.label} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span className={classes.overline}>{stat.label}</span>
              <span className={classes.bold} style={{ fontSize: 18 }}>{stat.value}</span>
            </div>
          ))}
        </div>
      </div>
    </DashboardCard>
  );
});

const SendHistory = observer(() => {
  const classes = useStatusDashboardStyles();
  const { statusDashboardStore: store } = useStatusDashboardStore();
  return (
    <DashboardCard title="Send history" right="Last 12 months, both channels">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {store.history.length === 0 && <span className={classes.muted}>No sends in the last 12 months</span>}
        {store.history.map(h => (
          <div
            key={h.key}
            className={classes.tableRow}
            style={{ gridTemplateColumns: HISTORY_COLUMNS, gap: 12 }}
          >
            <span className={classes.number} style={{ color: DASHBOARD_COLORS.muted }}>{h.date}</span>
            <span className={clsx(classes.overline, classes.bold)}>{h.channel}</span>
            <span className={clsx(classes.bold, classes.ellipsis)}>{h.campaign}</span>
            <span style={{ color: DASHBOARD_COLORS.muted }}>{h.detail}</span>
            <span>
              <StatusChip statusType={StatusType.BULK_SEND} label={h.status} variant="filled" size="small" />
            </span>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
});

export const RecipientHistoryTab = () => {
  const classes = useStatusDashboardStyles();
  return (
    <div className={classes.stack}>
      <RecipientSummary />
      <SendHistory />
    </div>
  );
};
